import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./authContext";
import './style.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const [lastChecked, setLastChecked] = useState(null);

  useEffect(() => {
    const now = new Date().toISOString();
    setLastChecked(now);
  }, [user]);

  // Show loading indicator while Firebase auth is initializing
  if (loading) {
    return (
      <div className="auth-loading-container">
        <div className="auth-loading-spinner"></div>
        <div className="auth-loading-text">Verifying your authentication...</div>
      </div>
    );
  }

  // If not loading and no user, redirect to login
  if (!user) {
    return <Navigate to="/login" />;
  }

  // User is authenticated, render the protected content
  return children;
};

export default ProtectedRoute;
